/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2024-03-11 16:26:21
 * @LastEditors: linxi
 * @LastEditTime: 2024-11-18 14:16:29
 */
import { API_PREFIX } from './constant'
import { Request } from './request'

export interface LocalVerificationFormListParams {
  startTime?: any
  endTime?: any
  yidibz?: any
  searchWay?: string
}

export function LocalVerificationFormList(
  params: LocalVerificationFormListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-insurance/insurance/getAppropriationBD`,
    method: 'GET',
    params,
  }
}

export function LocalVerificationFormListExport(
  params: LocalVerificationFormListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-insurance/insurance/getAppropriationBD/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params
  }
}


